import React, { Component } from "react";
import "./sliders.css";

class Sliders extends Component {
  render() {
    if (this.props.toggleSliders) {
      return (
        <div>
          <div className='s-div'>Danceability</div>
          <input
            className="slider"
            type="range"
            min="0"
            value={this.props.dancebility}
            max="2"
            step="1"
            list="ticks"
            onChange={(e) => this.props.onDance(e)}
          />
          <div className='s-div'>Energy</div>
          <input
            className="slider"
            type="range"
            min="0"
            value={this.props.energy}
            max="2"
            step="1"
            list="ticks"
            onChange={(e) => this.props.onEnergy(e)}
          />
          <div className='s-div'>Instrumentalness</div>
          <input
            className="slider"
            type="range"
            min="0"
            value={this.props.instrumentalness}
            max="2"
            step="1"
            list="ticks"
            onChange={(e) => this.props.onInstrum(e)}
          />
          <div className='s-div'>Valence</div>
          <input
            className="slider"
            type="range"
            min="0"
            value={this.props.valence}
            max="2"
            step="1"
            list="ticks"
            onChange={(e) => this.props.onValence(e)} 
          />
        </div>
      );
    } else {
      return null;
    }
  }
}

export default Sliders;



// WEBPACK FOOTER //
// ./src/sliders.js